<template>
    <div class="login__header">
        <div class="login__header-logo-box">
            <img class="login__header-logo" :src="`${$store.state.config.setup.logo}`" />
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';

export default {
    mixins: [languageMixins],

    data() {
        return {};
    },
    methods: {},
};
</script>
